// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"696d97a7","639":"8f2ed350"}[chunkId] + ".chunk.js";
};